import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteRelease } from 'imddata';
import { Redirect } from 'react-router-dom';
import { ConfirmationWindow } from 'imdshared';
import { Button, Icons } from 'imdui';

export const DeleteReleaseButton = ({ id }: { id: number | string }) => {
  const { t } = useTranslation();

  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openNotAvailableConfirmation, setOpenNotAvailableConfirmation] =
    useState(false);

  const {
    deletable,
    deleteEntry,
    request: { deleting, deleted },
  } = useDeleteRelease({ id });

  const handleButtonClick = () => {
    if (deletable) {
      setOpenNotAvailableConfirmation(true);
    } else {
      setOpenConfirmation(true);
    }
  };

  return (
    <>
      <Button
        key="button"
        icon={Icons.actions.trash}
        onClick={handleButtonClick}
        text={t('delete')}
      />

      {deleted && <Redirect to="/library/releases" />}

      <ConfirmationWindow
        loading={deleting}
        disabled={deleting}
        headerAlign="center"
        message={t('confirm-delete-release-text')}
        title={t('confirm-delete-release')}
        isOpen={openConfirmation}
        onConfirm={deleteEntry}
        onRequestClose={() => {
          setOpenConfirmation(false);
        }}
      />

      <ConfirmationWindow
        headerAlign="center"
        message={t('delete-release-not-available-for-delivered-asset')}
        title={t('delete-release')}
        isOpen={openNotAvailableConfirmation}
        onRequestClose={() => {
          setOpenNotAvailableConfirmation(false);
        }}
      />
    </>
  );
};
